"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBank = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsFinancial_1 = require("../../model/hsFinancial");
var service_1 = require("../../../library/base/service");
var CheckBank = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CheckBank, _super);
    function CheckBank() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '判断交易所是否绑卡';
        _this.code = '105042';
        _this.desc = '判断交易所是否绑卡';
        _this.requestParams = new hsFinancial_1.CheckBankRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CheckBank;
}(service_1.BaseService));
exports.CheckBank = CheckBank;
//# sourceMappingURL=checkBank.js.map